import { axios, getConfigs } from './common';

export default class RecipientService {
  async getList(params) {
    return new Promise(async (resolve, reject) => {
      let url = `/recipients`;

      const options = {};
      const configs = getConfigs('get', 'application/json', url, options);

      configs.params = params;

      axios(configs, resolve, reject);
    });
  }

  async import(file) {
    return new Promise(async (resolve) => {
      const fr = new FileReader();
      fr.onloadend = () => {
        const recipientString = fr.result.replace(/(\r\n|\n|\r)/gm, "");

        resolve(recipientString.split(',').filter(x => x !== ''));
      };

      fr.readAsText(file);
    });
  }
}
